import { render, staticRenderFns } from "./sysStudentWrite.vue?vue&type=template&id=119aafdf&scoped=true&"
import script from "./sysStudentWrite.vue?vue&type=script&lang=js&"
export * from "./sysStudentWrite.vue?vue&type=script&lang=js&"
import style0 from "./sysStudentWrite.vue?vue&type=style&index=0&id=119aafdf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119aafdf",
  null
  
)

export default component.exports